import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      // do not redirect during auth callback handling
      if (!window.location.hash.includes('session_id=')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

// API helpers
export const apiAuth = {
  me: () => api.get('/auth/me'),
  exchangeSession: (session_id) => api.post('/auth/google/session', { session_id }),
  logout: () => api.post('/auth/logout'),
  loginPassword: (payload) => api.post('/auth/login', payload),
  register: (payload) => api.post('/auth/register', payload),
};

export const apiSites = {
  list: () => api.get('/sites'),
  create: (data) => api.post('/sites', data),
  update: (code, data) => api.patch(`/sites/${code}`, data),
  remove: (code) => api.delete(`/sites/${code}`),
};

export const apiPermits = {
  list: (params) => api.get('/permits', { params }),
  stats: () => api.get('/permits/stats'),
  get: (id) => api.get(`/permits/${id}`),
  create: (data) => api.post('/permits', data),
  update: (id, data) => api.patch(`/permits/${id}`, data),
  changeStatus: (id, status, commentaire) =>
    api.post(`/permits/${id}/status`, { status, commentaire }),
  sign: (id, signer_role, signature_data) =>
    api.post(`/permits/${id}/sign`, { signer_role, signature_data }),
  duplicate: (id) => api.post(`/permits/${id}/duplicate`),
  remove: (id) => api.delete(`/permits/${id}`),
  pdfUrl: (id, mode = 'template') => `${API}/permits/${id}/pdf?mode=${mode}`,
  pdfBlob: (id, mode = 'template') => api.get(`/permits/${id}/pdf`, { params: { mode }, responseType: 'blob' }),
  notifyDonneurOrdre: (id) => api.post(`/permits/${id}/notify-donneur-ordre`),
};

export const apiUsers = {
  list: () => api.get('/users'),
  update: (uid, data) => api.patch(`/users/${uid}`, data),
  remove: (uid) => api.delete(`/users/${uid}`),
};

export const apiBugs = {
  list: () => api.get('/bug-reports'),
  create: (data) => api.post('/bug-reports', data),
};

export const apiATTemplates = {
  list: () => api.get('/at-templates'),
  create: (data) => api.post('/at-templates', data),
  remove: (id) => api.delete(`/at-templates/${id}`),
  instantiate: (id) => api.post(`/at-templates/${id}/instantiate`),
};

export const apiRefs = {
  all: (site) => api.get('/refs/all', { params: { site } }),
  companies: () => api.get('/refs/companies'),
  lafargeContacts: () => api.get('/refs/lafarge_contacts'),
  pdp: (entreprise) => api.get('/refs/pdp', { params: { entreprise } }),
  inductions: (entreprise, site) => api.get('/refs/inductions', { params: { entreprise, site } }),
  equipments: (site) => api.get('/refs/equipments', { params: { site } }),
  operations: (equipement, site) => api.get('/refs/operations', { params: { equipement, site } }),
  energies: (equipement, operation, site) => api.get('/refs/energies', { params: { equipement, operation, site } }),
};

export const apiLafargeContacts = {
  list: (params) => api.get('/admin/lafarge-contacts', { params }),
  create: (data) => api.post('/admin/lafarge-contacts', data),
  update: (id, data) => api.patch(`/admin/lafarge-contacts/${id}`, data),
  remove: (id) => api.delete(`/admin/lafarge-contacts/${id}`),
  importFromXlsx: (mode = 'merge') => api.post(`/admin/lafarge-contacts/import`, null, { params: { mode } }),
};
